module.exports = __webpack_public_path__ + "static/media/V Mohitha.9532548c.png";